import { FLEX_FILL } from '../../../constants/headerTreatments';

export function Phone({ treatment, ...props }) {
  const style = {
    a: {
      textDecoration: 'none'
    }
  };

  if (treatment === FLEX_FILL) {
    style.fontSize = 'large';
  }

  return this.Text(
    this.merge(
      {
        typography: 'BodyBeta',
        featured: true,
        style
      },
      props
    )
  );
}

export function MembershipHeading(props) {
  return this.Text(
    this.merge(
      {
        typography: 'BodyAlpha',
        style: {
          paddingHorizontal: 'medium',
          paddingBottom: 0,
          cursor: 'auto'
        }
      },
      props
    )
  );
}
